import React, { PureComponent } from 'react'
import Router from 'next/router'

import IconCaretDown from 'Images/SVG/CaretDown.svg'
import { P } from 'components/generic/HomePageComponents'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import {
  Dropdown,
  DropdownContent,
  DropDownContentContainer,
  AnchorsContainer,
  DropdownFilterInput,
  FacetDropdownAnchor,
  DropdownCenteredContent,
  FacetAnchorContainer,
  FacetDropdownContainer,
} from 'components/Directories/SearchFacetsContainer/Styled'

class LanguageDropdown extends PureComponent {
  state = {
    showDropdown: false,
    selectedLanguage: (this.props.selectedLanguage && this.props.selectedLanguage.label) || '',
    filterableLanguages: this.props.languages,
  }

  dropdownRef = React.createRef()
  inputRef = React.createRef()
  anchorRef = React.createRef()

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
    Router.events.on('routeChangeStart', () => {
      this.setState({ showLocationDropdown: false })
    })
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    const { languages } = this.props
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      // Hide dropdown and reset list
      this.setState({ showDropdown: false, filterableLanguages: languages })
    } else if (
      this.inputRef &&
      this.inputRef.current &&
      this.inputRef.current.contains(event.target)
    ) {
      this.setState({ showDropdown: true })
    } else if (
      this.anchorRef &&
      this.anchorRef.current &&
      this.anchorRef.current.contains(event.target)
    ) {
      this.setState({ showDropdown: true })
    } else {
      this.setState((prevState) => ({
        showDropdown: !prevState.showDropdown,
        filterableLanguages: languages,
      }))
    }
  }

  filterList = (event) => {
    const value = event && event.target && event.target.value && event.target.value
    const { languages } = this.props
    let updatedList = languages

    updatedList = updatedList.filter((language) => {
      if (
        language &&
        language.label &&
        event.target &&
        event.target.value &&
        language.label.toLowerCase().search(value.toLowerCase()) !== -1
      ) {
        return language
      }
    })

    const emptySearchInput = value.trim() === ''
    if (updatedList.length === 0 && !emptySearchInput) {
      updatedList = []
    }

    if (emptySearchInput) {
      updatedList = languages
    }

    this.setState({ filterableLanguages: updatedList, selectedLanguage: value })
  }

  setLanguage = (language) => {
    this.setState({ selectedLanguage: language && language.label })
    this.props.setLanguage(language && language.id)
  }

  render() {
    const { showDropdown, filterableLanguages, selectedLanguage } = this.state
    const propsLang = this.props.selectedLanguage && this.props.selectedLanguage.label

    const Anchors =
      filterableLanguages && filterableLanguages.length > 0 ? (
        filterableLanguages.map((language, i) => {
          return (
            <FacetAnchorContainer key={i} onClick={() => this.setLanguage(language)}>
              <FacetDropdownAnchor>{language.label}</FacetDropdownAnchor>
            </FacetAnchorContainer>
          )
        })
      ) : (
        <FacetDropdownAnchor p='1px 0px 1px 16px' height='fit-content'>
          No results found
        </FacetDropdownAnchor>
      )

    return (
      <>
        <P lineHeight='20px' fontWeight='bold' fontSize='14px' margin='25px 0px 3px'>
          Language
        </P>
        <FacetDropdownContainer
          backgroundColor={showDropdown ? '#ebebeb' : 'white'}
          borderColor={showDropdown ? '#66afe9' : '#ccc'}
          showDropdown={showDropdown}
          ref={this.dropdownRef}
          minWidth='220px'
        >
          <DropdownCenteredContent>
            <div>
              <Dropdown minWidth='180px'>
                <DropdownFilterInput
                  type='text'
                  onChange={this.filterList}
                  ref={this.inputRef}
                  value={!propsLang ? '' : selectedLanguage}
                  placeholder='Search By Language'
                  width='100%'
                  margin='0'
                  border='none'
                />
                <DropdownContent
                  showDropdown={showDropdown}
                  borderColor={showDropdown ? '#66afe9' : '#ccc'}
                  ref={this.anchorRef}
                >
                  <DropDownContentContainer width='220px'>
                    <AnchorsContainer>{Anchors}</AnchorsContainer>
                  </DropDownContentContainer>
                </DropdownContent>
              </Dropdown>
            </div>
          </DropdownCenteredContent>
          <GenericLazyLoadImage
            src={IconCaretDown}
            alt='Down Button'
            width='16px'
            height='18px'
            mt='8px'
            mr='8px'
          />
        </FacetDropdownContainer>
      </>
    )
  }
}

export default LanguageDropdown
